import { jsx as _jsx } from "react/jsx-runtime";
import InviteRegister from "./InviteRegister";
import RegisterClosed from "./RegisterClosed";
export default function Register() {
    const params = new URLSearchParams(window.location.search);
    const inviteCode = (params.get("invite") || "").trim();
    const invitedEmail = (params.get("email") || "").trim();
    if (inviteCode && invitedEmail) {
        return _jsx(InviteRegister, {});
    }
    return _jsx(RegisterClosed, {});
}
